import { render } from "./NewCropField.vue?vue&type=template&id=5b722001"
import script from "./NewCropField.vue?vue&type=script&lang=js"
export * from "./NewCropField.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/organization/partners/producers/new_crop_field.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Forganization%2Fpartners%2Fproducers%2FNewCropField.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/crop_field.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Forganization%2Fpartners%2Fproducers%2FNewCropField.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__